import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, Paper, Button, Grid, Box, Typography, TextField, Snackbar } from "@mui/material";
import logo from "../../logoCC.png";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "../../utils/Spinner";
import logoSm from "../../logo.png";

const SendFormPage = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openAlertError, setOpenAlertError] = React.useState(false);

  // const apiBaseUrl = "http://localhost:4000"; 
  // const apiBaseUrl = "https://siniestros-backend-vmly.onrender.com";
  const apiBaseUrl = "https://siniestros-backend-app.onrender.com";

  axios.defaults.baseURL = apiBaseUrl;

  const fetchForm = async (formData) => {
    setIsLoading(true);

    try {
      await axios.post("/sendForm", formData, {
        headers: { "Content-Type": "application/json" },
      });
      setOpenAlert(true);
      reset();
    } catch (err) {
      console.error(err);
      setOpenAlertError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setOpenAlert(false);
    setOpenAlertError(false);
  };

  const onSubmit = async (data) => {
    fetchForm(data);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <Container maxWidth="md" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", fontFamily: "'Inter', sans-serif" }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
            <img src={logoSm} alt="Logo" width={60} />
            <Typography variant="h5" align="center" sx={{ mt: 2 }}>Envío de formulario</Typography>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mt: 3 }}>
              <TextField
                {...register("nSiniestro", { required: "El número de siniestro es obligatorio" })}
                label="Nº de siniestro"
                fullWidth
                required
                sx={{ mb: 2, mt: 2 }}
                error={!!errors.nSiniestro}
                helperText={errors.nSiniestro?.message}
              />

              <TextField
                {...register("correo", {
                  required: "El correo electrónico es obligatorio",
                  pattern: {
                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Formato de correo no válido",
                  },
                })}
                label="Email del afectado"
                type="email"
                fullWidth
                required
                sx={{ mb: 2 }}
                error={!!errors.correo}
                helperText={errors.correo?.message}
              />
            </Box>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={6}>
                <Button type="button" component={Link} to="/forms" variant="outlined" color="secondary" fullWidth>
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button type="submit" variant="contained" color="primary" fullWidth>
                  Enviar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
        <div style={{textAlign: "center", marginTop: "10px"}}>
          <img src={logo} alt="Logo CodeCanario" width={120}/>
        </div>
      </Container>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={openAlert} autoHideDuration={6000} onClose={handleClose} message="Formulario enviado con éxito" />
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={openAlertError} autoHideDuration={6000} onClose={handleClose} message="Error al enviar el formulario" />
    </>
  );
};

export default SendFormPage;
